import React from 'react';
import type { FC, ReactNode } from 'react';
import { Box } from 'ink';
import { Alert } from './Alert.js';

export interface ErrorDetailsProps {
  /* Shortly describes what went wrong (aka WHAT) */
  message: ReactNode;
  /* Detailed explanation why error happened (aka WHY) */
  explanation?: ReactNode;
  /* Possible hints, instructions for a user how to fix it (aka HOW) */
  hint?: ReactNode;
}

export const ErrorDetails: FC<ErrorDetailsProps> = ({
  message,
  explanation,
  hint,
}) => (
  <Box flexDirection="column">
    <Alert type="error">{message}</Alert>
    {explanation && <Alert type="warning">{explanation}</Alert>}
    {hint && (
      <Box paddingTop={1}>
        <Alert type="insight">{hint}</Alert>
      </Box>
    )}
  </Box>
);
